import PageHero from "@/components/PageHero";
import ApproachTimeline from "@/sections/ApproachTimeline";
import WhoWeWorkWith from "@/sections/WhoWeWorkWith";
import CTABlock from "@/components/CTABlock";

export default function Approach() {
  return (
    <div data-testid="approach-page">
      <PageHero
        testId="approach-page-hero"
        label="Our Approach"
        title="From unclear"
        accent="to operational."
        subtitle="Every engagement follows a deliberate sequence — clarity first, infrastructure second, automation third, and continuous operational improvement throughout."
      />
      <ApproachTimeline withHeader={false} />
      <WhoWeWorkWith />
      <CTABlock />
    </div>
  );
}
